export class PasswordValidator {
  public static readonly REQUIRED_LENGTH = 8;

  public validate(password: string): PasswordValidity {
    let hasRequiredLength = false;

    if (password.length >= PasswordValidator.REQUIRED_LENGTH) {
      hasRequiredLength = true;
    }

    return {
      valid: hasRequiredLength,
      hasRequiredLength
    };
  }
}

export type PasswordValidity = {
  valid: boolean;
  hasRequiredLength: boolean;
};
